import request from '@/utils/request'

// 模糊查询公司列表
export function queryListByFuzzy(query) {
  return request({
    url: '/crmCompanyInfo/queryListByFuzzy',
    method: 'get',
    params: query
  })
}

// 查询公司工商信息
export function getCompanyDetail(query) {
  return request({
    url: '/crmCompanyInfo/getCompanyDetail',
    method: 'get',
    params: query
  })
}

// 查询公司工商信息
export function getCompanyInfoCount(data) {
  return request({
    url: '/companyInfo/count',
    method: 'post',
    data: data
  })
}
